import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import DetailsFetched from './details-fetched';

export default function({ ...props }) {
  const {
    customerDetails: { detailsIneligible },
  } = useSelector(state => state.pageText);
  return (
    <Wrapper>
      <DetailsFetched {...props} ineligable={true} />
      <p>{detailsIneligible}</p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  p {
    color: red;
  }
`;
